export default {
  Dashboard: {
    view: "Dashboard::View",
  },
  Departments: {
    view: "Departments::View",
    list: "Departments::List",
    create: "Departments::Create",
    edit: "Departments::Edit",
    delete: "Departments::Delete",
  },
  Roles: {
    view: "Roles::View",
    list: "Roles::List",
    create: "Roles::Create",
    edit: "Roles::Edit",
    delete: "Roles::Delete",
  },
  Users: {
    view: "Users::View",
    list: "Users::List",
    create: "Users::Create",
    edit: "Users::Edit",
    delete: "Users::Delete",
  },
  Trustees: {
    view: "Trustees::View",
    list: "Trustees::List",
    create: "Trustees::Create",
    edit: "Trustees::Edit",
    delete: "Trustees::Delete",
  },
  TrusteeSchemes: {
    view: "TrusteeSchemes::View",
    create: "TrusteeSchemes::Create",
    edit: "TrusteeSchemes::Edit",
    delete: "TrusteeSchemes::Delete",
  },
  Audits: {
    view: "Audits::View",
    list: "Audits::List",
  },
  BusinessDevelopment: {
    create: "BusinessDevelopment::Opportunities::Create",
    list: "BusinessDevelopment::Opportunities::List",
    view: "BusinessDevelopment::Opportunities::View",
    metrics: "BusinessDevelopment::Opportunities::Metrics",
    reassign: "BusinessDevelopment::Opportunities::ReassignUser",
    moveToWon: "BusinessDevelopment::Opportunities::MoveToWon",
    interactions: {
      summary:
        "BusinessDevelopment::Opportunities::OpportunityInteractions::Summary",
      list: "BusinessDevelopment::Opportunities::OpportunityInteractions::List",
      view: "BusinessDevelopment::Opportunities::OpportunityInteractions::View",
      create:
        "BusinessDevelopment::Opportunities::OpportunityInteractions::Create",
      edit: "BusinessDevelopment::Opportunities::OpportunityInteractions::Edit",
      delete:
        "BusinessDevelopment::Opportunities::OpportunityInteractions::Delete",
    },
    changeLog: "BusinessDevelopment::Opportunities::ChangeLog::List",
  },
  AUMTargets: {
    list: "AUMTargets::List",
    view: "AUMTargets::View",
    create: "AUMTargets::Create",
    edit: "AUMTargets::Edit",
    delete: "AUMTargets::Delete",
  },
  Templates: {
    list: "Templates::List",
    view: "Templates::View",
    create: "Templates::Create",
    edit: "Templates::Edit",
    delete: "Templates::Delete",
  },
  Products: {
    view: "Products::View",
    list: "Products::List",
    create: "Products::Create",
    edit: "Products::Edit",
    delete: "Products::Delete",
    createEzHomeProductPrice: "EzHomeProductPrice::Create",
  },
  ProductCategories: {
    view: "ProductCategories::View",
    list: "ProductCategories::List",
    create: "ProductCategories::Create",
    edit: "ProductCategories::Edit",
    delete: "ProductCategories::Delete",
  },
  ProductStatements: {
    view: "ProductStatements::View",
    manage: "ProductStatements::Manage",
    reschedule: "ProductStatements::Reschedule",
  },
  Customers: {
    list: "Customers::List",
    view: "Customers::View",
    create: "Customers::Create",
    edit: "Customers::Edit",
    delete: "Customers::Delete",
    changelogList: "Customers::ChangeLog::List",
    interactions: {
      edit: "CustomerInteractions::Edit",
      changeLogList: "CustomerInteractions::ChangeLog::List",
    },
    liens: {
      list: "Customers::Lien::List",
      create: "Customers::Lien::Create",
      delete: "Customers::Lien::Delete",
      view: "Customers::Lien::View",
    },
    companyAssociation: {
      delete: "Customers::CompanyAssociation::Delete",
    },
    payoutAccount: {
      delete: "Customers::PayoutAccount::Delete",
    },
    tags: {
      manage: "Customers::Tags::Manage",
    },
  },
  Companies: {
    list: "Companies::List",
    view: "Companies::View",
    create: "Companies::Create",
    edit: "Companies::Edit",
    delete: "Companies::Delete",
    changelogList: "Companies::ChangeLog::List",
    notifyReturnedCheque: "Companies::NotifyReturnedCheque",
    interactions: {
      edit: "CompanyInteractions::Edit",
      changelogList: "CompanyInteractions::ChangeLog::List",
    },
    liens: {
      list: "Companies::Lien::List",
      create: "Companies::Lien::Create",
      delete: "Companies::Lien::Delete",
      view: "Companies::Lien::View",
    },
    tags: {
      manage: "Companies::Tags::Manage",
    },
    closurePeriods: {
      add: "Companies::ClosedIntervals::Add",
      delete: "Companies::ClosedIntervals::Delete",
    },
    ports: {
      create: "Ports::Create",
      view: "Ports::View",
      edit: "Ports::Edit",
      delete: "Ports::Delete",
      list: "Ports::List",
      assignToPort: "Ports:AssignPort",
    },
    teams: {
      create: "Teams::Create",
      view: "Teams::View",
      edit: "Teams::Edit",
      delete: "Teams::Delete",
      list: "Teams::List",
    },
    payoutAccount: {
      delete: "Companies::PayoutAccount::Delete",
    },
  },
  TransferRequests: {
    create: "TransferRequests::Create",
    list: "TransferRequests::List",
    view: "TransferRequests::View",
    edit: "TransferRequests::Edit",
    delete: "TransferRequests::Delete",
  },
  RedemptionRequests: {
    create: "RedemptionRequests::Create",
    list: "RedemptionRequests::List",
    view: "RedemptionRequests::View",
    edit: "RedemptionRequests::Edit",
    delete: "RedemptionRequests::Delete",
    deal: {
      insertion: "RedemptionRequests::DealInsertion",
    },
  },
  NotifierRecords: {
    list: "NotifierRecords::List",
    view: "NotifierRecords::View",
  },
  BulkUploads: {
    list: "BulkUploads::List",
    view: "BulkUploads::View",
  },
  Ussd: {
    list: "Ussd::List",
    view: "Ussd::View",
  },
  ChangeRequests: {
    create: "ChangeRequests::Create",
    list: "ChangeRequests::List",
    view: "ChangeRequests::View",
    edit: "ChangeRequests::Edit",
    delete: "ChangeRequests::Delete",
  },
  Entitlements: {
    list: "Entitlements::List",
    view: "Entitlements::View",
    exception: {
      create: "Entitlements::CreateException",
      delete: "Entitlements::DeleteException",
    },
  },
  ExclusionLists: {
    create: "ExclusionLists::Create",
    list: "ExclusionLists::List",
    view: "ExclusionLists::View",
    edit: "ExclusionLists::Edit",
    delete: "ExclusionLists::Delete",
  },
  OnlineTransactions: {
    list: "OnlineTransactions::List",
    view: "OnlineTransactions::View",
    edit: "OnlineTransactions::Edit",
  },
  CompanyActivities: {
    create: "CompanyActivities::Create",
    list: "CompanyActivities::List",
    view: "CompanyActivities::View",
    edit: "CompanyActivities::Edit",
    delete: "CompanyActivities::Delete",
  },
  Qpr: {
    generate: "QPR::Generate",
  },
  CustomerSubscriptions: {
    delete: "CustomerSubscriptions::Delete",
    create: "CustomerSubscriptions::Create",
    edit: "CustomerSubscriptions::Edit",
  },
  CompanySubscriptions: {
    delete: "CompanySubscriptions::Delete",
    create: "CompanySubscriptions::Create",
  },
  EconomicIndicators: {
    create: "EconomicIndicators::Create",
    list: "EconomicIndicators::List",
    view: "EconomicIndicators::View",
    edit: "EconomicIndicators::Edit",
    delete: "EconomicIndicators::Delete",
  },
  LoanProviders: {
    create: "LoanProviders::Create",
    list: "LoanProviders::List",
    view: "LoanProviders::View",
    edit: "LoanProviders::Edit",
    delete: "LoanProviders::Delete",
  },
  LoanRequests: {
    create: "LoanRequests::Create",
    list: "LoanRequests::List",
    view: "LoanRequests::View",
    edit: "LoanRequests::Edit",
    delete: "LoanRequests::Delete",
  },
  FixedIncomeRequests: {
    create: "FixedIncomeRequests::Create",
    list: "FixedIncomeRequests::List",
    view: "FixedIncomeRequests::View",
    edit: "FixedIncomeRequests::Edit",
    delete: "FixedIncomeRequests::Delete",
  },
};
